import styled from 'styled-components'

const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1003;
`

const ModalContent = styled.div`
    background-color: var(--main-bg-color);
    padding: 20px;
    border-radius: 5px;
`

export {
    ModalWrapper,
    ModalContent
}